<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            color="primary"
            type="gradient"
            class="mb-4 md:mb-0"
            @click="add"
            >Add New Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          @keyup="search"
          placeholder="Search..."
        />
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Number</th>
              <th>Chart Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="6" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td>{{ item.number }}</td>
              <td>{{ item.chart_name }}</td>
              <td style="width: 90px">
                <div v-if="item.id !== 0" class="flex">
                  <vx-tooltip text="Edit" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="success"
                      class="mr-2"
                      @click="edit(index)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Delete" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      @click="del(item.id)"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                label="Number"
                class="w-full"
                type="number"
                v-model="input.number"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                label="Chart Name"
                class="w-full"
                type="text"
                v-model="input.chart_name"
              />
            </div>
          </div>
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Grade</label>
              <v-select
                :options="gradeSelectList"
                :disabled="action == 'edit'"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.grade"
              />
            </div>
            <div
              v-if="actor.privilege < 4"
              class="vx-col md:w-1/2 sm:w-1/2 w-full"
            >
              <label class="text-sm">Owner (Username)</label>
              <v-select
                :disabled="action == 'edit'"
                @search="searchOwner"
                :options="ownerFilterList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.userId"
              />
            </div>
          </div> -->
          <div class="vx-row mb-5"></div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
              <vs-button
                v-show="action === 'add'"
                color="warning"
                type="border"
                @click="reset"
                class="mb-2"
                >Reset</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      actor: {},
      data: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,

      tempId: 0,
      tempOwner: 0,

      gradeList: [
        'Best Driver',
        'Good Driver',
        'Satisfactory Driver',
        'Driver Need Improvement'
      ],
      gradeSelectList: [
        {
          value: 0,
          label: 'Best Driver'
        },
        {
          value: 1,
          label: 'Good Driver'
        },
        {
          value: 2,
          label: 'Satisfactory Driver'
        },
        {
          value: 3,
          label: 'Driver Need Improvement'
        }
      ],

      refAlertList: [],
      ownerFilterList: [],

      input: {
        number: '',
        chart_name: ''
      },

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.initTable()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {
    this.getRefAlert()
  },

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        if (item === 'status')
          this.input[item] = this.statusList.find((item) => {
            return item.value === 1
          })
        this.input[item] = ''
      })
    },

    initTable() {
      this.loading = true
      this.$http
        .get(
          `${this.$api.endpoint}/dashboard_chart/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchOwner(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/owner`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              branch: this.actor.privilege == 3 ? this.actor.branch : '',
              search: search
            }
          })
          .then((res) => {
            this.ownerFilterList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.ownerFilterList = []
      }
    },

    getOwnerList() {
      this.$http
        .get(`${this.$api.endpoint}/user/owner`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            branch: this.actor.privilege < 3 ? '' : this.actor.branch
          }
        })
        .then((res) => {
          this.ownerFilterList = res.data.message.data
          if (this.tempOwner) {
            this.input.userId = this.ownerFilterList.find((item) => {
              return item.value === this.tempOwner
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getRefAlert() {
      this.$http
        .get(`${this.$api.endpoint}/ref_alert/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.refAlertList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    add() {
      if (this.action === 'edit') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Chart Name'
      this.ownerFilterList = []
      this.showPopup = true
    },

    edit(index) {
      this.action = 'edit'
      this.popupTitle = 'Edit Chart Name'

      const data = this.data[index]

      this.tempId = data.id
      this.input.number = data.number
      this.input.chart_name = data.chart_name

      this.showPopup = true
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Dashboard Chart`,
        text: 'Are you sure want to Delete this data ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/dashboard_chart/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/dashboard_chart/add`
          : `${this.$api.endpoint}/dashboard_chart/update/${this.tempId}`

      this.$http
        .post(
          url,
          {
            number: parseInt(this.input.number),
            chart_name: this.input.chart_name
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()
          this.reset()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
